import { Component } from '@angular/core';
import { BasePageComponent } from '../../../../shared/components/base-page/base-page.component';

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss'],
})
export class AccountPageComponent extends BasePageComponent{

  constructor() {
    super();
  }


}
